<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sf_code,sd_custname"
      placeholder="输入客户、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sd_id"
        :to="'/sale/forecast/' + item.sf_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sd_custname}}</p>
          <p class="list-item-muted">{{item.pr_detail}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.sf_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sf_status!='已审核'}"
          >{{item.sf_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
    </div>
    <add-button to="/sale/forecast_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/saleforecast/list",
      filters: [
        {
          type: "date",
          name: "sf_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL"
            },
            {
              value: 1,
              label: "待下单",
              condition:
                "ifnull(sd_qty,0)>ifnull(sd_yqty,0) and sf_statuscode='AUDITED' and ifnull(sd_bussStatuscode,' ')<>'CLOSE'",
              mode: "DETAIL"
            },
            {
              value: 2,
              label: "已下单",
              condition:
                "ifnull(sd_qty,0)=ifnull(sd_yqty,0) and sf_statuscode='AUDITED' and ifnull(sd_bussStatuscode,' ')<>'CLOSE'",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "已取消",
              condition: "ifnull(sd_bussStatuscode,' ')='CLOSE'",
              mode: "DETAIL"
            }
          ]
        }
      ],
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10
      }
    };
  }
};
</script>